module.exports = __webpack_public_path__ + "img/shirt_happy.fe467733.gif";